module.exports = __webpack_public_path__ + "img/40_69_000_070.89bacc82.jpg";